const NOT_AUTHORIZED_ERROR = "[NOT_AUTHORIZED_ERROR]:";

/**
 *  Check if the error is an unauthorized error
 */
export function isNotAuthorizedApiError(error?: unknown) {
  return (error as any)?.code === 401;
}

export function generateNotAuthorizedError(error?: unknown) {
  return new Error(
    `${NOT_AUTHORIZED_ERROR}${(error as any)?.message ?? "Unknow"}`,
    {
      cause: error,
    }
  );
}

export function isNotAuthorizedPageError(error?: Error) {
  return error?.message?.startsWith(NOT_AUTHORIZED_ERROR);
}
